import { LazyComponent } from './components/LazyComponent/LazyComponent.js';

export const StandaloneAccountSettings = LazyComponent(() =>
  import(
    /* webpackChunkName: "StandaloneAccountSettings" */ '@cld-remote/account_settings/index'
  ).then((module) => ({
    default: module.StandaloneAccountSettings,
  }))
);

export const SideBarMenu = LazyComponent(() =>
  import(/* webpackChunkName: "SideBarMenu" */ '@cld-remote/account_settings/index').then(
    (module) => ({
      default: module.SideBarMenu,
    })
  )
);

export const SettingsAppContext = LazyComponent(() =>
  import(/* webpackChunkName: "SettingsAppContext" */ '@cld-remote/account_settings/index').then(
    (module) => ({
      default: module.SettingsAppContext,
    })
  )
);
